"use strict";

import axios from "axios";

import * as app from "./../components/app";

export const init = (ctx, next) => {
  let url = "";
  if (ctx.querystring !== "") {
    ctx.querystring.split("&").forEach((q) => {
      const p = q.split("=");
      if (p[0] == "url") url = p[1];
    });
  }

  const canvas = document.querySelector("#canvas");
  if (!canvas) {
    return;
  }

  if (url !== "") {
    axios
      .post(
        `${app.config.bespokePath}${url}`,
        {},
        {
          headers: {
            "kotive-contact-token": localStorage.getItem("contact-email") + ":" + localStorage.getItem("contact-token"),
          },
        }
      )
      .then((resp) => {
        // Create a fragment to parse the HTML
        const fragment = document.createRange().createContextualFragment(resp.data);

        // Find all scripts in the fragment
        const scripts = fragment.querySelectorAll("script");

        // Replace the canvas with the new content
        canvas.replaceWith(fragment);

        // Re-create and append each script to the head to execute it
        scripts.forEach((oldScript) => {
          const newScript = document.createElement("script");

          // Copy all attributes from the old script to the new one
          Array.from(oldScript.attributes).forEach((attr) => {
            newScript.setAttribute(attr.name, attr.value);
          });

          // Copy the inline script content
          if (oldScript.innerHTML) {
            newScript.text = oldScript.innerHTML;
          }

          // Append the new script to the head, which will execute it
          document.head.appendChild(newScript);
        });
      })
      .catch((err) => {
        console.error(err);
      });
  } else {
    canvas.textContent = "Not found";
  }
};
